import { render, staticRenderFns } from "./SkillsSelectionModal.vue?vue&type=template&id=404b4a0a&scoped=true&"
import script from "./SkillsSelectionModal.vue?vue&type=script&lang=js&"
export * from "./SkillsSelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./SkillsSelectionModal.vue?vue&type=style&index=0&id=404b4a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404b4a0a",
  null
  
)

export default component.exports